import { Fragment, useState } from 'react'
import { Show, SimpleShowLayout, useRecordContext } from 'react-admin'
import { url2 } from '../utils'
import { Box, Typography, makeStyles } from '@material-ui/core'
import {
  createTheme,
  ThemeProvider as MuiThemeProvider,
} from '@material-ui/core/styles'
import ApartmentIcon from '@mui/icons-material/Apartment'
import { TIMEZONE } from '../config'
import moment from 'moment-timezone'

// == Below are deprecated comments about footer handling ==
//
// - pour éviter que 1 bloc de résolution morde sur le footer en bas de page: on a déjà un page-break avoid sur chaque bloc de résolution. Du coup il suffit de mettre un placeholder ayant la height du footer, en-dessous de chaque bloc de résolution.
// --> stratégie de type 1: on fait en sorte que chaque unité de no-page-break ait un blanc juste en dessous de la height du footer, comme ça pas d'overlap

// - pour éviter que la liste des copropriétaires ne morde sur le footer: ici on peut pas utiliser la stratégie de type 1, si on ajoute un blanc de la taille du footer en-dessous de chaque ligne ça va être trop galère.
// Du coup on va faire des blocks prenant chacun tt une page
// --> stratégie de type 2: on fait des batchs auxquels on applique la stratégie de type 1. Chaque bloc doit prendre plus de 1/2 page height,
//pour pas en avoir 2 sur une mm page séparés par un placeholder

// - pour éviter que l'ordre du jour (liste des intitulés de résolutions au début) ne morde sur le footer, on va faire des packets de 10, et sur chaque packet de 10 on met un no page break inside, et un placeholder juste en-dessous de la taille du footer
// --> stratégie de type 2

// - pour éviter que le texte trop long d'une résolution morde sur le footer: trop galère de deviner
// la height d'un texte de résolution, pour le moment on a simplement réduit la fontSize des Typography
//
// == End of the deprecated comments about footer handling ==

// From now on, to deal with the footer we followed this link, section "ULTIMATE METHOD" at the bottom
// https://medium.com/@Idan_Co/the-ultimate-print-html-template-with-header-footer-568f415f6d2a

const useStyles = makeStyles((theme) => ({
  apartmentInfoWrapper: {
    display: 'flex',
  },
  apartmentIcon: {
    fontSize: '56px',
    color: theme.palette.grey.A100,
  },
  resolutionTitle: {
    borderBottom: `2px solid ${theme.palette.grey.A100}`,
  },
  resolutionResult: {
    borderTop: `1px dotted black`,
    borderBottom: `1px dotted black`,
    textAlign: 'center',
    padding: '4px 0',
    marginTop: '0.35em',
  },
  noLineHeight: {
    lineHeight: '1',
  },
  withMargin: {
    marginLeft: `20px`,
  },
}))

const customTheme = createTheme({
  overrides: {
    body: {
      root: {
        backgroundColor: 'blue',
      },
    },
  },
  palette: {
    primary: {
      main: '#143A5F',
      contrastText: '#ffffff',
    },
  },
  typography: {
    fontFamily: 'Helvetica',
    fontSize: 8,
  },
})

const BaseUnit = (props) => (
  <div style={{ breakInside: 'avoid' }}>{props.children}</div>
)

const Title = ({ record }) => {
  const classes = useStyles()
  record = record || useRecordContext()
  return (
    <Fragment>
      <Typography variant="h5">
        <b>
          Ordre du jour de l'assemblée générale{' '}
          {record.estordinaire ? 'ordinaire' : 'extraordinaire'} du{' '}
          {moment
            .utc(record.dateprevisionnelle)
            .tz(TIMEZONE)
            .format('DD MMMM YYYY')}
        </b>
      </Typography>
      <Typography variant="subtitle2" color="black">
        {record.ag_libelle}
      </Typography>
      <Typography variant="subtitle2" color="black" gutterBottom>
        <b>
          Date de l'AG :{' '}
          {moment.utc(record.dateprevisionnelle).tz(TIMEZONE).format('LLL')}
        </b>
        <br />
        <b>Lieu : {record.lieu}</b>
      </Typography>
      <div className={classes.apartmentInfoWrapper}>
        <ApartmentIcon className={classes.apartmentIcon} />
        <Typography variant="subtitle2">
          <b>Immeuble</b>
          <br />
          {record.libelle}
          <br />
          {record.adresse} {record.codepostal} {record.ville}
        </Typography>
      </div>
      <br />
      <Typography variant="body2">
        Cette Assemblée sera appelée à délibérer exclusivement sur l'ordre du
        jour suivant :
      </Typography>
    </Fragment>
  )
}

const ResolutionTitle = ({ record }) => (
  <Fragment>
    <Typography variant="body2">
      <b>
        {record.numero}) {record.libelle}
      </b>{' '}
      - Majorité {record.majorite_bo}
    </Typography>
  </Fragment>
)

const Footer = () => (
  <div
    className="footer"
    style={{ position: 'fixed', bottom: '5px', left: '10px' }}
  >
    <Box display="flex">
      <Box flex={2} mr="0.5em" ml="0.5em">
        <img
          src={url2}
          style={{ maxWidth: '10vw', marginTop: '0px', marginLeft: '25px' }}
        />
      </Box>
      <Box flex={4} mr="0.5em" ml="0.5em">
        <Typography variant="caption" style={{ fontSize: '0.40rem' }}>
          Manda (Ex-Hello Syndic) SAS au capital de 31.015 € - 828 499 897 RCS
          PARIS, ayant son siège social 30 Terrasse Bellini - 92800 Puteaux, N°
          de TVA intracommunautaire : FR 27 828499897 Carte professionnelle CPI
          7501 2017 000 019 252 RCS de Paris, garantie financière auprès de
          GALIAN.
        </Typography>
      </Box>
      <Box flex={1} mr="0.5em" ml="0.5em">
        &nbsp;
      </Box>
    </Box>
  </div>
)

const splitArrayChunks = (arr, chunk_length) => {
  var nb_blocks = Math.floor(arr.length / chunk_length)
  var new_arr = []
  for (var k = 0; k < nb_blocks; k++) {
    new_arr.push(arr.slice(k * chunk_length, (k + 1) * chunk_length))
  }
  new_arr.push(arr.slice(nb_blocks * chunk_length, arr.length))
  return new_arr
}

const IntroResolutions = (props) => {
  var block_length = 20
  let record = useRecordContext(props)
  var chunks = splitArrayChunks(record.resolutions, block_length)
  return (
    <div>
      {chunks.map((c, i1) => {
        return (
          <BaseUnit key={i1}>
            {c.map((e, i2) => {
              return (
                <div key={i2}>
                  <ResolutionTitle record={e} />
                </div>
              )
            })}
          </BaseUnit>
        )
      })}
    </div>
  )
}

export const PvAgConvocation = (props) => {
  const [open_resolution_id, setOr] = useState(null)
  const [not_ready, setR] = useState(false)
  const { withMargin } = useStyles()
  return (
    <MuiThemeProvider theme={customTheme}>
      <table className={withMargin}>
        <tbody>
          <tr>
            <td>
              <Show {...props}>
                <SimpleShowLayout elevation={0}>
                  <Title />
                  <IntroResolutions />
                </SimpleShowLayout>
              </Show>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td>
              <div style={{ height: '50px' }}>&nbsp;</div>
            </td>
          </tr>
        </tfoot>
      </table>
      <Footer />
    </MuiThemeProvider>
  )
}
